module.exports = __webpack_public_path__ + "img/multiplier_normal_5.5754e24f.png";